export default __webpack_public_path__ + "static/media/phone_1.a8c06c16.webp";